export const getTowerCost = (towerType: string): number => {
  switch (towerType) {
    case "archer":
      return 50;
    case "mage":
      return 80;
    default:
      return 50;
  }
};
